<module-container>
  <div class="title-container">
    <h2>Global Supplier Type</h2>
  </div>
  <abcis-table [configuration]="tableConfig" (linkClick)="onLinkClick($event)"></abcis-table>
</module-container>

<p-dialog
  [header]="modalHeader"
  [(visible)]="displayPromptModal"
  [style]="{ width: '90vw', maxWidth: '600px' }"
  [modal]="true"
  [baseZIndex]="10000"
>
  <textarea
    readonly
    [value]="promptValue"
    style="width: 100%; height: 50vh; min-height: 200px; resize: none; overflow: auto"
  ></textarea>
</p-dialog>
